var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Tooltip } from '@hn-ui/tooltips';
import { useWeeklyDashboardAnalytics, WeeklyDashboardEvents, } from '../../../../hooks/useWeeklyDashboardAnalytics';
import { cutText } from '../../../../utils/text';
var TAG_MAX_LENGTH = 13;
var SubTxt = styled.p.withConfig({ displayName: "SubTxt", componentId: "sc-1ayj2v0" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #777b8b;\n\n  font-size: 13px;\n  line-height: 16px;\n"], ["\n  color: #777b8b;\n\n  font-size: 13px;\n  line-height: 16px;\n"])));
var TxtNoWrapNoMargin = styled.p.withConfig({ displayName: "TxtNoWrapNoMargin", componentId: "sc-1nh1wch" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n\n  margin: 0;\n\n  color: ", ";\n\n  font-size: 16px;\n  line-height: 24px;\n  white-space: nowrap;\n"], ["\n  display: inline-block;\n\n  margin: 0;\n\n  color: ", ";\n\n  font-size: 16px;\n  line-height: 24px;\n  white-space: nowrap;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blackText;
});
var AreaOfFocusCell = function (_a) {
    var areaOfFocus = _a.areaOfFocus, isTbd = _a.isTbd;
    var sendGaEvent = useWeeklyDashboardAnalytics();
    return (_jsx("div", { children: isTbd ? (_jsxs(_Fragment, { children: [_jsx(Tooltip, __assign({ content: 'Data will be available after student completes the Placement test', maxWidth: '320px' }, { children: _jsx(TxtNoWrapNoMargin, { children: "TBD" }, void 0) }), void 0), _jsx(SubTxt, { children: "-" }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx(Tooltip, __assign({ content: areaOfFocus.tagName.length > TAG_MAX_LENGTH
                        ? areaOfFocus.tagName
                        : '', interactive: areaOfFocus.tagName.length > TAG_MAX_LENGTH, maxWidth: 'none' }, { children: _jsx(TxtNoWrapNoMargin, __assign({ onMouseEnter: function () {
                            return sendGaEvent(WeeklyDashboardEvents.studentCurrentAreaOfFocusHover);
                        } }, { children: cutText(areaOfFocus.tagName, TAG_MAX_LENGTH) }), void 0) }), void 0), _jsx(SubTxt, { children: areaOfFocus.positionAbbreviation }, void 0)] }, void 0)) }, void 0));
};
export { AreaOfFocusCell };
var templateObject_1, templateObject_2;
